import type { communications as en } from '@/i18n/locales/en/communications';
import type { Translation } from '@/i18n/types';

export const communications: Translation<typeof en> = {
  page: {
    title: 'Επικοινωνία',
    lead: 'Συντάξτε και προγραμματίστε ειδοποιήσεις για την {{company}}.',
    noScope: 'Επιλέξτε μια εταιρεία για να δείτε την επικοινωνία της.',
    forbidden: 'Δεν επιτρέπεται να δείτε την επικοινωνία αυτής της εταιρείας.',
  },
  composer: {
    title: 'Νέα ειδοποίηση',
    titleField: 'Τίτλος',
    message: 'Μήνυμα',
    category: 'Κατηγορία',
    audience: 'Ομάδα-στόχος',
    date: 'Ημερομηνία',
    time: 'Ώρα',
    callToAction: 'Κάλεσμα για δράση',
    quietHours: 'Σεβασμός ωρών ησυχίας',
    quietHoursHint: 'Καθυστέρηση παράδοσης εκτός 08:00–20:00.',
    submit: 'Αποθήκευση ως πρόχειρο',
    schedule: 'Προγραμματισμός',
    send: 'Αποστολή τώρα',
  },
  categories: {
    algemeen: 'Γενικά',
    veiligheid: 'Ασφάλεια',
    evenement: 'Εκδήλωση',
    vitaliteit: 'Ζωτικότητα',
    hr: 'HR',
  },
  audiences: {
    iedereen: 'Όλοι',
    management: 'Διοίκηση',
    per_afdeling: 'Ανά τμήμα',
    per_locatie: 'Ανά τοποθεσία',
  },
  status: {
    concept: 'Πρόχειρο',
    ingepland: 'Προγραμματισμένο',
    verzonden: 'Απεστάλη',
  },
  log: {
    title: 'Αρχείο αποστολών',
    empty: 'Καμία επικοινωνία ακόμη.',
    columns: {
      message: 'Μήνυμα',
      category: 'Κατηγορία',
      reach: 'Εμβέλεια',
      openRate: 'Ποσοστό ανοίγματος',
      status: 'Κατάσταση',
    },
  },
  actions: {
    new: 'Νέα ειδοποίηση',
    cancel: 'Ακύρωση',
    markScheduled: 'Σήμανση ως προγραμματισμένο',
    markSent: 'Σήμανση ως απεσταλμένο',
  },
};
